export default __webpack_public_path__ + "fonts/73d978f46335be61e9aa592a76d34f4e.ttf";